<p>solicitudes works!</p>
<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>Blog Single - Company Bootstrap Template</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
  />
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>





<body>
  <section style="background-color: rgb(255, 255, 255);margin-top: 100px;" id="services" class="services section-bg">

    <section>
      <div class="container animate__animated animate__fadeInDown" >



        <div class="row justify-content-center" style="border: solid; border-radius: 2vh; border-color: rgb(255, 255, 255); box-shadow: -5px 6px 20px 0px rgba(0, 0, 0, 0.753);">
          <div class="col-12 col-md-8 col-lg-8 col-xl-6">
            <form [formGroup]="nuevoPC" (ngSubmit)="postForm(this.nuevoPC.value)" action="">
            <div class="row">
              <div class="col text-center">
                <img width="94" height="94" src="https://img.icons8.com/3d-fluency/94/writer-male.png" alt="writer-male"/> <h1>Datos Generales</h1>
                <p style="margin-top: 1vh;" class="text-h3">Rellene los datos para continuar su registro. </p>
              </div>
            </div>


            <div class="row align-items-center mt-4 form-floating mb-3">
              <input  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="EMPRESA">
              <label for="floatingInput">Nombre de la Empresa</label>
            </div>


            <div class="row align-items-center mt-4 form-floating mb-3">
              <input  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="TELEFONO">
              <label for="floatingInput">Teléfono</label>
            </div>


            <div class="row align-items-center mt-4 form-floating mb-3">
              <input  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="CODIGO">
              <label for="floatingInput">Código Postal</label>
            </div>


            <div class="row align-items-center mt-4 form-floating mb-3">
              <input type="number"  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="NUM_EMPLEADOS">
              <label for="floatingInput">No. Empleados</label>
            </div>

            <div class="row align-items-center mt-4 form-floating mb-3">
              <input  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="REPRESENTANTE">
              <label for="floatingInput">Representante L</label>
            </div>


            <div class="row align-items-center mt-4 form-floating mb-3">
              <input  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="ORGA_DIST_LAB">
              <label for="floatingInput">Solicitante</label>
            </div>


            <div class="row align-items-center mt-4 form-floating mb-3">
              <input  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="AFOROS">
              <label for="floatingInput">Aforos(fijos y flotantes)</label>
            </div>


            <div class="row align-items-center mt-4 form-floating mb-3">
              <input  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="POLIZA_SEG">
              <label for="floatingInput">Poliza de Seguros</label>
            </div>



            <div class="row align-items-center mt-4 form-floating mb-3">
              <input  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="INMUEBLE">
              <label for="floatingInput">Información sobre la construcción del inmueble</label>
            </div>



            <div class="row align-items-center mt-4 form-floating mb-3">
              <input  class="form-control" id="floatingInput" placeholder="name@example.com" formControlName="PIPC">
              <label for="floatingInput">Introducción sobre el PIPC en su centro de trabajo</label>
            </div>



            <div class="row justify-content-start mt-4">
              <div class="col">

                <button type="submit"  class="btn  mt-4" style="width: 100%;margin-bottom: 5vh;background-color: hwb(359 2% 24%);color: rgb(255, 255, 255);">Siguiente</button>
              </div>
            </div>

          </form>
          </div>
        </div>
      </div>
    </section>



  </section><!-- End Services Section -->


  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i
      class="bi bi-arrow-up-short"></i></a>

  <!-- Vendor JS Files -->
  <script src="/assets/vendor/aos/aos.js"></script>
  <script src="/assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
  <script src="/assets/vendor/glightbox/js/glightbox.min.js"></script>
  <script src="/assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>
  <script src="/assets/vendor/swiper/swiper-bundle.min.js"></script>
  <script src="/assets/vendor/waypoints/noframework.waypoints.js"></script>
  <script src="/assets/vendor/php-email-form/validate.js"></script>

  <!-- Template Main JS File -->
  <script src="/assets/js/main.js"></script>

</body>

</html>
